import { useEffect } from 'react';

const SITE_NAME = '布丁漫画网';

function getSiteUrl(): string {
  const basePath =
    typeof __BASE_PATH__ !== 'undefined'
      ? __BASE_PATH__.split('/').filter(Boolean).join('/')
      : '';
  const pathPrefix = basePath ? `/${basePath}` : '';
  return `${window.location.origin}${pathPrefix}`;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  if (!content) {
    return;
  }
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function renderJsonLd(objects: Record<string, unknown>[]) {
  document.head
    .querySelectorAll('script[data-seo-jsonld]')
    .forEach((s) => s.remove());
  if (!objects.length) {
    return;
  }
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo-jsonld', 'true');
  script.textContent = JSON.stringify(objects);
  document.head.appendChild(script);
}

export interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
  path?: string;
  ogImage?: string;
  jsonLd?: Record<string, unknown>[];
}

export function useSeo(options: SeoOptions) {
  const { title, description, keywords, path = '/', ogImage, jsonLd = [] } =
    options;
  const jsonKey = JSON.stringify(jsonLd);

  useEffect(() => {
    document.title = title;
    const siteUrl = getSiteUrl();
    const canonical = `${siteUrl}${path === '/' ? '' : path}`;

    upsertCanonical(canonical);
    upsertMeta('name', 'description', description || '');
    upsertMeta('name', 'keywords', keywords || '');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description || '');
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:image', ogImage || '');
    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('property', 'og:locale', 'zh_CN');
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description || '');
    upsertMeta('name', 'twitter:image', ogImage || '');
    renderJsonLd(jsonLd);
  }, [title, description, keywords, path, ogImage, jsonKey]);
}